import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import { getBlog } from "@/lib/api";
import { Reveal } from "@/lib/motion";
import { Overline, GoldLink } from "@/components/ui-kit";
import { useSeo } from "@/lib/useSeo";

export default function BlogPost() {
  const { slug } = useParams();
  const { data: b, isLoading, isError } = useQuery({ queryKey: ["blog", slug], queryFn: () => getBlog(slug) });
  useSeo({ title: b?.title, description: b?.excerpt, image: b?.image });

  if (isLoading) return <div className="pt-44 text-center text-ink/50">Loading…</div>;
  if (isError || !b) return <div className="pt-44 text-center" data-testid="blog-not-found"><p className="font-display text-4xl">Article not found</p><Link to="/blog" className="text-bronze link-underline mt-4 inline-block">Back to Journal</Link></div>;

  return (
    <article data-testid="blog-post-page" className="pt-32 md:pt-40">
      <div className="mx-auto max-w-[820px] px-6 md:px-10">
        <Link to="/blog" className="text-ink/60 text-sm uppercase tracking-[0.2em] font-bold flex items-center gap-2 hover:text-bronze mb-8"><ArrowLeft size={16} /> Journal</Link>
        <Overline>{b.category} · {b.read_time}</Overline>
        <h1 className="font-display text-4xl md:text-6xl leading-[1.05] mt-4">{b.title}</h1>
        <p className="text-ink/50 text-sm mt-5">By {b.author} · {b.date}</p>
      </div>
      <div className="mx-auto max-w-[1100px] px-6 md:px-10 mt-10">
        <div className="overflow-hidden rounded-md">
          <img src={b.image} alt={b.title} className="w-full h-[40vh] md:h-[60vh] object-cover" />
        </div>
      </div>
      <div className="mx-auto max-w-[720px] px-6 md:px-10 py-14">
        {b.body.split("\n\n").map((p, i) => (
          <Reveal key={i} delay={i * 0.04}><p className="text-lg text-ink/80 leading-[1.9] mb-6">{p}</p></Reveal>
        ))}
        <div className="mt-10 pt-8 border-t border-gold/20"><GoldLink to="/book-consultation" testid="blogpost-cta">Start Your Project</GoldLink></div>
      </div>
    </article>
  );
}
